import React from 'react';
const stats = [{
  number: '6',
  label: 'tomów PDF gotowych do użycia'
}, {
  number: '40',
  label: 'tygodni planów lekcji'
}, {
  number: '160+',
  label: 'gotowych planów zajęć'
}, {
  number: '4',
  label: 'poziomy U12–U18'
}, {
  number: '6',
  label: 'dodatkowych bonusów'
}, {
  number: '0',
  label: 'miesięcznych opłat'
}];
export function Numbers() {
  return <section className="w-full py-12 md:py-20 px-4 md:px-6" style={{
    background: '#112240'
  }} data-id="element-199">
      <div className="max-w-6xl mx-auto" data-id="element-200">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-201">
          W liczbach:
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8" data-id="element-202">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-203">
              <div className="font-display font-bold text-5xl sm:text-6xl md:text-7xl leading-none mb-2 tabular-nums" style={{
            color: '#FFD700'
          }} data-id="element-204">
                {stat.number}
              </div>
              <p className="text-sm md:text-base text-[#E8EAF0] leading-tight" data-id="element-205">
                {stat.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}